(function(){
  'use strict';
  const db=()=>window.SM.DB, ui=()=>window.SM.UI, util=()=>window.SM.UTIL;

  async function load(){
    const content=document.getElementById('ims-backup-content');
    if(!content)return;
    content.innerHTML=`<div class="ims__loading"><i class="ti ti-loader-2 ims__spin"></i></div>`;
    const isSuperAdmin=window.SM.AUTH.hasRole('super_admin');
    const isAdmin=window.SM.AUTH.hasRole('admin');
    if(!isSuperAdmin&&!isAdmin){
      content.innerHTML=`<div class="ims__coming-soon"><i class="ti ti-lock"></i><h3>Access denied</h3><p>Backup and restore is available to Admin and Super Admin only.</p></div>`;
      return;
    }
    content.innerHTML=`
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px">
        <div class="ims__card">
          <div class="ims__card-header"><div class="ims__card-title"><i class="ti ti-download"></i>Backup</div></div>
          <p style="font-size:13px;color:var(--ims-text-sec);margin-bottom:14px">Download a full backup of all your StockMaestro data as a JSON file. Store securely.</p>
          <button class="ims__btn ims__btn--primary" onclick="window.IMS_BACKUP.downloadBackup()"><i class="ti ti-download"></i> Download full backup</button>
        </div>
        <div class="ims__card">
          <div class="ims__card-header"><div class="ims__card-title"><i class="ti ti-upload"></i>Restore</div></div>
          <p style="font-size:13px;color:var(--ims-text-sec);margin-bottom:14px">Restore from a previously downloaded backup file. This will overwrite current data.</p>
          <div class="ims__form-group" style="margin-bottom:12px">
            <input type="file" accept=".json" id="ims-restore-file" class="ims__input" onchange="window.IMS_BACKUP.previewRestore(this)">
          </div>
          <div id="ims-restore-preview"></div>
        </div>
        <div class="ims__card">
          <div class="ims__card-header"><div class="ims__card-title"><i class="ti ti-file-download"></i>Import templates</div></div>
          <p style="font-size:13px;color:var(--ims-text-sec);margin-bottom:14px">Download blank CSV templates for bulk data import.</p>
          <div class="ims__btn-group" style="flex-wrap:wrap">
            <button class="ims__btn ims__btn--secondary ims__btn--sm" onclick="window.IMS_BACKUP.downloadTemplate('products')"><i class="ti ti-box"></i> Products</button>
            <button class="ims__btn ims__btn--secondary ims__btn--sm" onclick="window.IMS_BACKUP.downloadTemplate('customers')"><i class="ti ti-users"></i> Customers</button>
            <button class="ims__btn ims__btn--secondary ims__btn--sm" onclick="window.IMS_BACKUP.downloadTemplate('suppliers')"><i class="ti ti-building-store"></i> Suppliers</button>
            <button class="ims__btn ims__btn--secondary ims__btn--sm" onclick="window.IMS_BACKUP.downloadTemplate('orders')"><i class="ti ti-shopping-cart"></i> Orders</button>
          </div>
        </div>
        <div class="ims__card">
          <div class="ims__card-header"><div class="ims__card-title"><i class="ti ti-info-circle"></i>System info</div></div>
          <table class="ims__table">
            <tbody>
              <tr><td>StockMaestro version</td><td style="font-weight:600">v2.1.0</td></tr>
              <tr><td>Developed by</td><td>ABSA Digital</td></tr>
              <tr><td>Company</td><td>${util().sanitize(window.SM.AUTH.company?.name||'—')}</td></tr>
              <tr><td>Database</td><td>Supabase (PostgreSQL)</td></tr>
              <tr><td>Your role</td><td>${util().formatRole(window.SM.AUTH.user?.role)}</td></tr>
              <tr><td>Last login</td><td>${util().formatDateTime(window.SM.AUTH.user?.last_login)}</td></tr>
            </tbody>
          </table>
        </div>
      </div>
      ${isSuperAdmin?`
        <hr class="ims__divider" style="margin:20px 0">
        <div class="ims__card" style="border-color:var(--ims-danger)">
          <div class="ims__card-header"><div class="ims__card-title" style="color:var(--ims-danger)"><i class="ti ti-alert-triangle"></i>Danger Zone — Audit Reset</div></div>
          <p style="font-size:13px;color:var(--ims-text-sec);margin-bottom:4px">Use these resets to wipe test/audit data after system testing. These actions are <strong>permanent and cannot be undone</strong>.</p>
          <p style="font-size:12px;color:var(--ims-text-muted);margin-bottom:16px">Never deleted: products, stock levels, customers, couriers, drivers, vehicles, routes, warehouses, platforms, users, company settings.</p>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px">
            <div style="padding:14px;border:1px solid var(--ims-danger);border-radius:var(--ims-radius);background:var(--ims-danger-bg)">
              <div style="font-weight:600;margin-bottom:6px;display:flex;align-items:center;gap:6px"><i class="ti ti-shopping-cart" style="color:var(--ims-danger)"></i>Reset all orders &amp; logistics</div>
              <p style="font-size:12px;color:var(--ims-text-sec);margin-bottom:10px">Deletes all non-dropship orders, order items, logistics jobs, manifests, shipments, COD transactions, finance transactions, courier follow-ups, claims, and activity logs.<br>Resets all stock reserved quantities to zero.</p>
              <button class="ims__btn ims__btn--danger ims__btn--sm" onclick="window.IMS_BACKUP.resetOrdersLogistics()"><i class="ti ti-trash"></i> Reset orders &amp; logistics</button>
            </div>
            <div style="padding:14px;border:1px solid var(--ims-danger);border-radius:var(--ims-radius);background:var(--ims-danger-bg)">
              <div style="font-weight:600;margin-bottom:6px;display:flex;align-items:center;gap:6px"><i class="ti ti-truck-delivery" style="color:var(--ims-danger)"></i>Reset dropship orders &amp; invoices</div>
              <p style="font-size:12px;color:var(--ims-text-sec);margin-bottom:10px">Deletes all dropship orders (fulfillment_type = dropship), their order items, logistics jobs, activity logs, dropship invoices, and invoice lines. Non-dropship orders are not touched.</p>
              <button class="ims__btn ims__btn--danger ims__btn--sm" onclick="window.IMS_BACKUP.resetDropship()"><i class="ti ti-trash"></i> Reset dropship data</button>
            </div>
          </div>
        </div>` : ''}`;
  }

  // ─── BACKUP ─────────────────────────────────────────────────────
  async function downloadBackup(){
    ui().toast('Preparing backup — this may take a moment...','info');
    const companyId=window.SM.AUTH.company?.id;
    const tables=[
      // System
      'companies','users','platforms','platform_terms',
      // Master data
      'warehouses','couriers','courier_rate_bands','courier_surcharges',
      'routes','vehicles','drivers',
      'customers','suppliers',
      'products','product_prices','product_boxes',
      'promotions','promotion_customers','promotion_products',
      'account_codes',
      // Orders & logistics
      'orders','order_items','order_discounts','order_batches','order_postcode_history',
      'order_activity_log','order_tracking_events',
      'purchase_orders','po_items',
      'imports','import_items','import_documents',
      'grn_records','grn_discrepancies',
      'logistics_jobs','manifests','manifest_items','shipments','courier_followups',
      'cod_transactions','driver_cod_accounts',
      'stock_levels','stock_movements','cycle_counts','cycle_count_items',
      'invoices','invoice_lines','accounts_payable','accounts_receivable','transactions',
      'claims',
      // Deals & allocations
      'deals','deal_customers','deal_platforms',
      'customer_allocations','allocation_activity_log',
      // Dropship
      'dropship_customers','dropship_orders','dropship_order_items',
      'dropship_invoices','dropship_allocations',
      // Other
      'notifications','archive_orders',
    ];
    const backup={
      version:'2.1.0',exported_at:new Date().toISOString(),
      company:window.SM.AUTH.company?.name,data:{}
    };
    const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
    for(const table of tables){
      try{
        const {data}=await client.from(table).select('*').eq('company_id',companyId);
        backup.data[table]=data||[];
      }catch(e){backup.data[table]=[];}
    }
    const json=JSON.stringify(backup,null,2);
    const blob=new Blob([json],{type:'application/json'});
    const a=document.createElement('a');
    a.href=URL.createObjectURL(blob);
    a.download=`stockmaestro_backup_${new Date().toLocaleDateString('en-GB').replace(/\//g,'-')}.json`;
    a.click();
    URL.revokeObjectURL(a.href);
    ui().toast('Backup downloaded successfully','success');
  }

  // ─── RESTORE ────────────────────────────────────────────────────
  let _restoreData=null;

  async function previewRestore(input){
    const file=input.files?.[0];
    if(!file)return;
    const preview=document.getElementById('ims-restore-preview');
    try{
      const text=await file.text();
      _restoreData=JSON.parse(text);
      if(!_restoreData.version||!_restoreData.data){
        if(preview)preview.innerHTML=`<div class="ims__alert ims__alert--danger"><i class="ti ti-alert-circle"></i><span>Invalid backup file format</span></div>`;
        _restoreData=null;return;
      }
      const tables=Object.keys(_restoreData.data);
      const totalRecords=tables.reduce((s,t)=>s+(_restoreData.data[t]?.length||0),0);
      if(preview)preview.innerHTML=`
        <div class="ims__alert ims__alert--warning"><i class="ti ti-alert-triangle"></i>
          <span><strong>Backup from:</strong> ${util().sanitize(_restoreData.exported_at?util().formatDateTime(_restoreData.exported_at):'')} | <strong>Version:</strong> ${_restoreData.version} | <strong>Company:</strong> ${util().sanitize(_restoreData.company||'Unknown')} | <strong>Records:</strong> ${totalRecords}</span>
        </div>
        <div class="ims__alert ims__alert--danger" style="margin-top:8px"><i class="ti ti-alert-triangle"></i><span>This will overwrite your current data. Make sure you have downloaded a current backup first.</span></div>
        <button class="ims__btn ims__btn--danger" style="margin-top:10px" onclick="window.IMS_BACKUP.confirmRestore()"><i class="ti ti-upload"></i> Restore this backup</button>`;
    }catch(e){
      if(preview)preview.innerHTML=`<div class="ims__alert ims__alert--danger"><i class="ti ti-alert-circle"></i><span>Failed to read file: ${e.message}</span></div>`;
      _restoreData=null;
    }
  }

  async function confirmRestore(){
    if(!_restoreData){ui().toast('No backup file loaded','error');return;}
    ui().confirm(
      'This will permanently overwrite all current data with the backup. Are you absolutely sure?',
      async()=>{
        ui().toast('Restore in progress — do not close this window...','warning',30000);
        const companyId=window.SM.AUTH.company?.id;
        const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
        const deleteTables=[
          'order_tracking_events','order_activity_log','claims',
          'deal_customers','deal_platforms','deals',
          'allocation_activity_log','customer_allocations',
          'manifest_items','logistics_jobs','manifests','shipments','courier_followups',
          'cod_transactions',
          'grn_discrepancies','grn_records','import_documents','import_items','imports',
          'order_discounts','order_items','order_batches','order_postcode_history',
          'orders','po_items','purchase_orders',
          'invoice_lines','invoices','accounts_payable','accounts_receivable','transactions',
          'cycle_count_items','cycle_counts','stock_movements',
          'dropship_order_items','dropship_invoices','dropship_orders',
          'dropship_allocations',
          'archive_orders','notifications',
        ];
        for(const t of deleteTables){
          try{await client.from(t).delete().eq('company_id',companyId);}catch(e){}
        }
        for(const[table,rows]of Object.entries(_restoreData.data)){
          if(!rows?.length)continue;
          try{await client.from(table).upsert(rows,{onConflict:'id'});}catch(e){console.warn(`Restore ${table}:`,e);}
        }
        ui().toast('Restore complete — reloading...','success');
        setTimeout(()=>location.reload(),2000);
      },
      'Yes, restore backup',true
    );
  }

  // ─── RESET A: ORDERS & LOGISTICS ────────────────────────────────
  async function resetOrdersLogistics(){
    if(!window.SM.AUTH.hasRole('super_admin')){ui().toast('Super Admin only','error');return;}
    ui().openModal('Reset orders & logistics',`
      <div class="ims__alert ims__alert--danger" style="margin-bottom:14px">
        <i class="ti ti-alert-triangle"></i>
        <span><strong>This will permanently delete:</strong><br>
        All non-dropship orders, order items, logistics jobs, manifests, shipments, COD transactions,
        finance transactions, claims, courier follow-ups, activity logs, GRN records, import records,
        purchase orders, invoices, and stock movements.<br><br>
        Stock reserved quantities will be reset to zero.<br><br>
        <strong>This cannot be undone.</strong></span>
      </div>
      <div class="ims__form-group">
        <label class="ims__label">Type <strong>RESET</strong> to confirm</label>
        <input class="ims__input" type="text" id="ims-resetol-confirm" placeholder="Type RESET here" style="border-color:var(--ims-danger)">
      </div>
    `,`
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--danger" onclick="window.IMS_BACKUP.executeResetOrdersLogistics()"><i class="ti ti-trash"></i> Reset now</button>
    `,'sm');
  }

  async function executeResetOrdersLogistics(){
    const val=document.getElementById('ims-resetol-confirm')?.value?.trim();
    if(val!=='RESET'){ui().toast('Please type RESET to confirm','error');return;}

    const companyId=window.SM.AUTH.company?.id;
    const client=window.supabase.createClient(
      window.IMS_SUPABASE_URL, window.IMS_SUPABASE_ANON_KEY,
      {global:{headers:{Authorization:`Bearer ${window.SM.AUTH.session?.access_token}`}}}
    );
    ui().closeModal();
    ui().toast('Resetting orders & logistics — do not close this window...','warning',60000);

    try{
      // Step 1 — Delete activity logs for non-dropship orders first
      // Get non-dropship order IDs first
      const {data:nonDsOrders}=await client.from('orders')
        .select('id').eq('company_id',companyId).neq('fulfillment_type','dropship');
      const nonDsIds=(nonDsOrders||[]).map(o=>o.id);

      if(nonDsIds.length){
        // Delete in batches of 100 to avoid URL length limits
        const batchSize=100;
        for(let i=0;i<nonDsIds.length;i+=batchSize){
          const batch=nonDsIds.slice(i,i+batchSize);
          await client.from('order_tracking_events').delete().in('order_id',batch);
          await client.from('order_activity_log').delete().in('order_id',batch);
          await client.from('order_discounts').delete().in('order_id',batch);
          await client.from('order_items').delete().in('order_id',batch);
          await client.from('order_postcode_history').delete().in('order_id',batch);
        }
        // Delete orders themselves
        for(let i=0;i<nonDsIds.length;i+=batchSize){
          const batch=nonDsIds.slice(i,i+batchSize);
          await client.from('orders').delete().in('id',batch);
        }
      }

      // Step 2 — Delete all company-level transactional data (not order-specific)
      const tables=[
        // Claims
        'claims',
        // Deals
        'deal_customers','deal_platforms','deals',
        // Allocations (non-dropship)
        'allocation_activity_log','customer_allocations',
        // Manifest & logistics
        'manifest_items','logistics_jobs','manifests','shipments','courier_followups',
        // COD
        'cod_transactions',
        // GRN
        'grn_discrepancies','grn_records',
        // Imports
        'import_documents','import_items','imports',
        // Order batches
        'order_batches',
        // Purchases
        'po_items','purchase_orders',
        // Finance
        'invoice_lines','invoices','accounts_payable','accounts_receivable','transactions',
        // Inventory history
        'cycle_count_items','cycle_counts','stock_movements',
        // Other
        'archive_orders','notifications',
      ];
      for(const t of tables){
        try{await client.from(t).delete().eq('company_id',companyId);}
        catch(e){console.warn(`Reset ${t}:`,e.message);}
      }

      // Step 3 — Reset stock reserved quantities to zero
      await client.from('stock_levels')
        .update({reserved_qty:0, reserved_by_allocations:0})
        .eq('company_id',companyId);

      // Step 4 — Reset driver COD balances to zero (keep driver records)
      await client.from('driver_cod_accounts')
        .update({balance:0})
        .eq('company_id',companyId);

      ui().toast('Orders & logistics reset complete. Reloading...','success');
      setTimeout(()=>location.reload(),2000);

    }catch(err){
      console.error('[Reset]',err);
      ui().toast('Reset failed: '+err.message,'error');
    }
  }

  // ─── RESET B: DROPSHIP DATA ──────────────────────────────────────
  async function resetDropship(){
    if(!window.SM.AUTH.hasRole('super_admin')){ui().toast('Super Admin only','error');return;}
    ui().openModal('Reset dropship data',`
      <div class="ims__alert ims__alert--danger" style="margin-bottom:14px">
        <i class="ti ti-alert-triangle"></i>
        <span><strong>This will permanently delete:</strong><br>
        All dropship orders and their order items, logistics jobs, activity logs,
        dropship invoices, invoice lines, and allocations.<br><br>
        Non-dropship retail and wholesale orders are <strong>not affected</strong>.<br><br>
        <strong>This cannot be undone.</strong></span>
      </div>
      <div class="ims__form-group">
        <label class="ims__label">Type <strong>RESET</strong> to confirm</label>
        <input class="ims__input" type="text" id="ims-resetds-confirm" placeholder="Type RESET here" style="border-color:var(--ims-danger)">
      </div>
    `,`
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--danger" onclick="window.IMS_BACKUP.executeResetDropship()"><i class="ti ti-trash"></i> Reset dropship now</button>
    `,'sm');
  }

  async function executeResetDropship(){
    const val=document.getElementById('ims-resetds-confirm')?.value?.trim();
    if(val!=='RESET'){ui().toast('Please type RESET to confirm','error');return;}

    const companyId=window.SM.AUTH.company?.id;
    const client=window.supabase.createClient(
      window.IMS_SUPABASE_URL, window.IMS_SUPABASE_ANON_KEY,
      {global:{headers:{Authorization:`Bearer ${window.SM.AUTH.session?.access_token}`}}}
    );
    ui().closeModal();
    ui().toast('Resetting dropship data — do not close this window...','warning',60000);

    try{
      // Step 1 — Get all dropship order IDs
      const {data:dsOrders}=await client.from('orders')
        .select('id').eq('company_id',companyId).eq('fulfillment_type','dropship');
      const dsIds=(dsOrders||[]).map(o=>o.id);

      if(dsIds.length){
        const batchSize=100;
        for(let i=0;i<dsIds.length;i+=batchSize){
          const batch=dsIds.slice(i,i+batchSize);
          await client.from('order_tracking_events').delete().in('order_id',batch);
          await client.from('order_activity_log').delete().in('order_id',batch);
          await client.from('order_items').delete().in('order_id',batch);
          await client.from('order_discounts').delete().in('order_id',batch);
          await client.from('logistics_jobs').delete().in('order_id',batch);
        }
        for(let i=0;i<dsIds.length;i+=batchSize){
          const batch=dsIds.slice(i,i+batchSize);
          await client.from('orders').delete().in('id',batch);
        }
      }

      // Step 2 — Delete dropship-specific tables
      const dsTables=[
        'dropship_order_items',
        'dropship_invoices',
        'dropship_orders',
        'dropship_allocations',
      ];
      for(const t of dsTables){
        try{await client.from(t).delete().eq('company_id',companyId);}
        catch(e){console.warn(`Reset ${t}:`,e.message);}
      }

      // Step 3 — Reset dropship reserved allocations on stock_levels
      await client.from('stock_levels')
        .update({reserved_by_allocations:0})
        .eq('company_id',companyId);

      ui().toast('Dropship data reset complete. Reloading...','success');
      setTimeout(()=>location.reload(),2000);

    }catch(err){
      console.error('[Reset Dropship]',err);
      ui().toast('Reset failed: '+err.message,'error');
    }
  }

  // ─── TEMPLATES ──────────────────────────────────────────────────
  function downloadTemplate(type){
    const templates={
      products:{
        headers:['SKU','Product Name','Category','Barcode','Unit','Cost Price','Wholesale Price','RRP','Reorder Threshold','Reorder Quantity','Default Bin','Notes'],
        rows:[['CHR-001','Example Chair','Furniture','1234567890','each','10.00','18.00','35.00','10','50','A-51','Sample product']]
      },
      customers:{
        headers:['Business Name','Contact Name','Email','Phone','Postcode','Address','VAT Number','Credit Terms','Credit Limit','Notes'],
        rows:[['Acme Furniture Ltd','John Smith','john@acme.com','07700900000','SW1A 1AA','1 Example St London','GB123456789','30 days net','5000','']]
      },
      suppliers:{
        headers:['Supplier Name','Contact Name','Email','Phone','Country','Currency','Payment Terms','VAT Number','Address','Notes'],
        rows:[['Best Supplier Ltd','Jane Doe','jane@supplier.com','01234567890','China','CNY','30 days net','','123 Factory Road','']]
      },
      orders:{
        headers:['Customer Name','Postcode','Address','Phone','Email','Platform','Product Name','SKU','Quantity','Unit Price','Notes'],
        rows:[['John Smith','SW1A 1AA','1 Example Street London','07700900000','john@email.com','Amazon UK','Example Chair','CHR-001','2','35.00','']]
      }
    };
    const tpl=templates[type];
    if(!tpl)return;
    util().exportCSV(tpl.headers,tpl.rows,`${type}_template`);
  }

  // ─── ARCHIVE ────────────────────────────────────────────────────
  async function archiveOrders(){
    const cutoff=new Date();
    cutoff.setMonth(cutoff.getMonth()-12);
    const {data:old}=await db().select('orders',{
      eq:{status:'delivered'},
      lte:{created_at:cutoff.toISOString()},
      select:'id,order_number,created_at'
    });
    if(!old?.length){ui().toast('No orders older than 12 months to archive','info');return;}
    ui().confirm(
      `Archive ${old.length} delivered orders from before ${util().formatDate(cutoff.toISOString().split('T')[0])}? They will be compressed and removed from the active database.`,
      async()=>{
        let archived=0;
        for(const order of old){
          const {data:full}=await db().select('orders',{
            select:'*, order_items(*)',eq:{id:order.id},maybeSingle:true,noCompanyFilter:true
          });
          await db().insert('archive_orders',{
            original_order_id:order.id,
            archived_at:new Date().toISOString(),
            data_snapshot:JSON.stringify(full)
          });
          const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
          await client.from('order_items').delete().eq('order_id',order.id);
          await client.from('logistics_jobs').delete().eq('order_id',order.id);
          await client.from('orders').delete().eq('id',order.id);
          archived++;
        }
        ui().toast(`${archived} orders archived successfully`,'success');
        load();
      },
      'Archive orders',false
    );
  }

  window.addEventListener('ims:panel',e=>{if(e.detail.panel==='backup')load();});
  window.IMS_BACKUP={
    load, downloadBackup, previewRestore, confirmRestore, downloadTemplate, archiveOrders,
    resetOrdersLogistics, executeResetOrdersLogistics,
    resetDropship, executeResetDropship
  };
})();